// Brand assets & content for Manifest with Waterboat
export const IMAGES = {
  heroNature:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_water-memory-1/artifacts/wxhszidr_1785243454963.png",
  memoryWater:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_water-memory-1/artifacts/pv9pig7h_IMG_20260731_190251.png",
  emotoCrystals:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_water-memory-1/artifacts/bp3tceg9_IMG_20260731_190455.png",
  sadhguruBoat:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_water-memory-1/artifacts/fpbw2fcs_IMG_20260731_190144.png",
  submerged:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_water-memory-1/artifacts/9549uij4_1780365153918.png",
  bottlePlain:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_ccfdb071-e65f-4b19-af2f-705745580d60/artifacts/ooguhg3h_1778209176646.png",
  mint:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_ccfdb071-e65f-4b19-af2f-705745580d60/artifacts/ag3bgsni_1779674387012.png",
  dining:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_ccfdb071-e65f-4b19-af2f-705745580d60/artifacts/r3dsebyr_1779693889771.png",
  waterReflection:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_ccfdb071-e65f-4b19-af2f-705745580d60/artifacts/cmbgniws_1780364811207.png",
  billboard:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_ccfdb071-e65f-4b19-af2f-705745580d60/artifacts/4ulz0jmr_1779075966433.png",
};

export const CONTACT = {
  instagram: "https://www.instagram.com/manifestwithwaterboat/",
  instagramHandle: "@manifestwithwaterboat",
  whatsapp: "https://wa.me/917720096181",
  whatsappLabel: "+91 77200 96181",
  email: "watermelonfnb@gmail.com",
};

export const CHAPTERS = [
  {
    no: "01",
    label: "THE MEMORY",
    title: "Water Remembers",
    body:
      "Water is not inert. It listens. Whatever is spoken, felt, or intended around it becomes imprinted in its structure — and returns to you the moment it is consumed.",
    image: IMAGES.memoryWater,
    tag: "MEMORY OF WATER",
  },
  {
    no: "02",
    label: "THE SCIENCE",
    title: "Dr. Emoto's Crystals",
    body:
      "Japanese Scientist Dr. Masaru Emoto observed the crystalline structure of frozen water which was exposed to words and emotions. Kindness and love formed radiant, symmetrical crystals. Cruelty and hatred formed chaos. The same water- reshaped by intention.",
    image: IMAGES.emotoCrystals,
    tag: "CRYSTALLINE STRUCTURE",
  },
  {
    no: "03",
    label: "THE WISDOM",
    title: "Sadhguru on Water",
    body:
      "The mystics always knew what science now measures — water carries the quality of everything it touches. Charge it with the right disposition, and every sip becomes a ritual.",
    image: IMAGES.sadhguruBoat,
    tag: "MYSTICAL SECRETS",
  },
];

export const MARQUEE_ITEMS = [
  "BELIEVE",
  "VISUALIZE",
  "MANIFEST",
  "COHERENCE",
  "ENTANGLEMENT",
  "ALIGNED WITH UNIVERSE",
];


export const FAMILY_HERO = "/family/family-hero.png?v=1";

// The 3-stage family — from the Watermelon Foods & Beverages brochure
export const PRODUCT_LINE = [
  {
    brand: "Bottled Stories",
    stage: "BELIEF",
    tagline: "Every bottle has its own story.",
    desc:
      "Where the journey begins. Everyday hydration that carries your moments, journeys and stories — easy to carry, easy to trust.",
    sizes: ["1L", "20L Jar"],
    image: "/family/stories.png?v=2",
    accent: "#6b8cff",
  },
  {
    brand: "Waterboat",
    stage: "ASPIRATION",
    tagline: "Rise. Align. Flow forward.",
    desc:
      "Infused with the spirit of movement and the power of manifestation. Purity, purpose and presence in every sip — unstoppable, like water itself.",
    sizes: ["1L", "500ml", "250ml", "200ml", "20L Jar"],
    image: "/family/waterboat.png?v=2",
    accent: "#5eead4",
  },
  {
    brand: "Manifest",
    stage: "ABUNDANCE",
    tagline: "Intended. Spiritual. Enlightened.",
    desc:
      "For those who think big, live consciously and visualize their achievements. Thoughtfully sourced water for everyday rituals of intention.",
    sizes: ["1L", "500ml"],
    image: "/family/manifest.png?v=2",
    accent: "#f5c542",
  },
];

export const CHARGING = [
  "Positive Water Affirmations",
  "Solfeggio Sound Therapy",
  "Water Prayers",
];
